import { render } from "./OvRemoveModal.vue?vue&type=template&id=1dd54402&scoped=true"
import script from "./OvRemoveModal.vue?vue&type=script&lang=js"
export * from "./OvRemoveModal.vue?vue&type=script&lang=js"

import "./OvRemoveModal.vue?vue&type=style&index=0&id=1dd54402&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dd54402"]])

export default __exports__